import { useWatchlistsBuilderApi } from '@/components/watchlists/WatchlistBuilderApi';
const watchlistApi = useWatchlistsBuilderApi();
export default {
  namespaced: true,
  state() {
    return {
      data: {
        coins: [],
        companies: [],
        apefluencer_accounts: [],
        news_items: [],
        onchain_addresses: [],
        loaded: {
          coins: false,
          companies: false,
          apefluencer_accounts: false,
          news_items: false,
          onchain_addresses: false
        },
        teamFolders: []
      }
    };
  },
  getters: {
    coins: state => state.data.coins,
    companies: state => state.data.companies,
    apefluencers: state => state.data.apefluencer_accounts,
    news_items: state => state.data.news_items,
    onchain_addresses: state => state.data.onchain_addresses,
    loaded: state => state.data.loaded,
    team_folders: state => state.data.team_folders
  },
  actions: {
    async setAllWatchlists({ commit }) {
      let response = await watchlistApi.getUserWatchlists([
        'coins',
        'companies',
        'apefluencer_accounts',
        'news_items',
        'onchain_addresses'
      ]);
      commit('setAllWatchlists', {
        coins: response.filter(x => x.watchlist_type == 'coins'),
        companies: response.filter(x => x.watchlist_type == 'companies'),
        apefluencer_accounts: response.filter(x => x.watchlist_type == 'apefluencer_accounts'),
        news_items: response.filter(x => x.watchlist_type == 'news_items'),
        onchain_addresses: response.filter(x => x.watchlist_type == 'onchain_addresses')
      });
      commit('setLoaded', 'all');
    },
    async setWatchlists({ commit, dispatch }, entity) {
      if (entity == 'coins') {
        await dispatch('setCoinsWatchlists');
      } else if (entity == 'companies') {
        await dispatch('setCompaniesWatchlists');
      } else if (entity == 'apefluencer_accounts') {
        await dispatch('setApefluencersWatchlists');
      } else if (entity == 'news_items') {
        await dispatch('setNewsItemsWatchlists');
      } else if (entity == 'onchain_addresses') {
        await dispatch('setOnchainAddressFolders');
      }
    },
    async setTeamFolders({ commit, dispatch }) {
      let response = await watchlistApi.getTeamWatchlists('onchain_addresses');
      commit('setTeamFolders', response);
    },
    async setCoinsWatchlists({ commit }) {
      let response = await watchlistApi.getUserWatchlists('coins');
      commit('setCoinsWatchlists', response);
      commit('setLoaded', 'coins');
    },
    async setCompaniesWatchlists({ commit }) {
      let response = await watchlistApi.getUserWatchlists('companies');
      commit('setCompaniesWatchlists', response);
      commit('setLoaded', 'companies');
    },
    async setApefluencersWatchlists({ commit }) {
      let response = await watchlistApi.getUserWatchlists('apefluencer_accounts');
      commit('setApefluencersWatchlists', response);
      commit('setLoaded', 'apefluencer_accounts');
    },
    async setNewsItemsWatchlists({ commit }) {
      let response = await watchlistApi.getUserWatchlists('news_items');
      commit('setNewsItemsWatchlists', response);
      commit('setLoaded', 'news_items');
    },
    async setOnchainAddressFolders({ commit }) {
      let response = await watchlistApi.getUserWatchlists('onchain_addresses');
      commit('setOnchainAddressFolders', response);
      commit('setLoaded', 'onchain_addresses');
    },
    async subscribeToWatchlist({ commit, dispatch }, id) {
      let response = await watchlistApi.subscribeToWatchlist(id);
      commit('resetLoaded', 'all');
      await dispatch('setAllWatchlists');
      return response;
    },
    async shareWatchlistToTeam({ commit, dispatch }, id) {
      let response = await watchlistApi.shareWatchlistToTeam(id);
      const watchlist = await dispatch('getWatchlistFromStore', id);
      if (watchlist) {
        commit('resetLoaded', watchlist.watchlist_type);
        await dispatch('setWatchlists', watchlist.watchlist_type);
      } else {
        commit('resetLoaded', 'all');
        await dispatch('setAllWatchlists');
      }
      return response;
    },
    async getTeamEntityPermissions({ commit }, id) {
      let response = await watchlistApi.getTeamEntityPermissions(id);
      return response;
    },
    async getWatchlist({ commit }, id) {
      let response = await watchlistApi.getWatchlist(id);
      return response;
    },
    async getWatchlists({ commit, state, dispatch }, entity) {
      if (!state.data.loaded[entity]) await dispatch('setWatchlists', entity);
      return state.data[entity];
    },
    async getMaintainers({ commit }, id) {
      let response = await watchlistApi.getMaintainers(id);
      return response;
    },
    async updateMaintainers({ commit, dispatch }, payload) {
      let response = await watchlistApi.updateMaintainers(
        payload.currentMaintainers,
        payload.newMaintainers,
        payload.watchlistId
      );
      const watchlist = await dispatch('getWatchlistFromStore', payload.watchlistId);

      if (watchlist) {
        commit('resetLoaded', watchlist.watchlist_type);
        await dispatch('setWatchlists', watchlist.watchlist_type);
      } else {
        commit('resetLoaded', 'all');
        await dispatch('setAllWatchlists');
      }
      return response;
    },
    async getTeamWatchlists({ commit }, entities) {
      let response = await watchlistApi.getTeamWatchlists(entities);
      return response;
    },
    async getCompanies({ commit }) {
      let response = await watchlistApi.getCompanies();
      return response;
    },
    async getTeammates({ commit }) {
      let response = await watchlistApi.getTeammates();
      return response;
    },
    async createWatchlist({ commit, dispatch }, payload) {
      let response = await watchlistApi.createWatchlist(payload);
      commit('resetLoaded', payload.watchlist_type);
      await dispatch('setWatchlists', payload.watchlist_type);
      return response;
    },
    async updateWatchlist({ commit, dispatch }, data) {
      let response = await watchlistApi.updateWatchlist(data.watchlistPayload, data.defaultPayload, this);
      commit('resetLoaded', data.watchlistPayload.watchlist_type);
      await dispatch('setWatchlists', data.watchlistPayload.watchlist_type);
      return response;
    },
    async deleteWatchlist({ commit }, id) {
      await watchlistApi.deleteWatchlist(id, this);
    },
    async deleteFolder({ commit }, id) {
      await watchlistApi.deleteFolder(id, this);
    },
    async deleteWatchlistFromStore({ commit }, id) {
      commit('deleteWatchlist', id);
    },
    async updateWatchlistEntity({ commit, dispatch }, payload) {
      await watchlistApi.updateWatchlistEntity(payload);
      await dispatch('setWatchlists', payload.entity);
    },
    async deleteWatchlistEntity({ commit, dispatch }, payload) {
      await watchlistApi.deleteWatchlistEntity(payload);
      await dispatch('setWatchlists', payload.entity);
    },
    async deleteUserEntityPermission({ commit }, id) {
      await watchlistApi.deleteUserEntityPermission(id);
      commit('deleteWatchlist', id);
    },
    async openAddToWatchlistModal({ commit, dispatch }, payload) {
      const watchlist_ids = await dispatch('includedInWatchlist', {
        entityObj: payload.entityObj,
        entity: payload.entity
      });
      commit(
        'openModal',
        {
          name: 'addToWatchlist',
          status: payload.status,
          payload: {
            payload: { ...payload.entityObj, watchlist_ids: watchlist_ids },
            mode: payload.mode,
            entity: payload.entity
          }
        },
        { root: true }
      );
    },
    async includedInWatchlist({ commit, dispatch }, payload) {
      const watchlists = await dispatch('getWatchlists', payload.entity);
      const id = payload.entity == 'coins' ? payload.entityObj.uid : payload.entityObj.id;
      return watchlists.filter(x => x.entities_uids.includes(id)).map(i => i.id);
    },
    getWatchlistFromStore({ state }, id) {
      return [
        ...state.data['coins'],
        ...state.data['companies'],
        ...state.data['apefluencer_accounts'],
        ...state.data['news_items'],
        ...state.data['onchain_addresses']
      ].find(w => w.id == id);
    }
  },
  mutations: {
    setAllWatchlists: (state, payload) => {
      state.data.coins = payload.coins;
      state.data.companies = payload.companies;
      state.data.apefluencer_accounts = payload.apefluencer_accounts;
      state.data.news_items = payload.news_items;
      state.data.onchain_addresses = payload.onchain_addresses;
    },
    setCoinsWatchlists: (state, payload) => {
      state.data.coins = payload;
    },
    setTeamFolders: (state, payload) => {
      state.data.team_folders = payload;
    },
    setCompaniesWatchlists: (state, payload) => {
      state.data.companies = payload;
    },
    setApefluencersWatchlists: (state, payload) => {
      state.data.apefluencer_accounts = payload;
    },
    setNewsItemsWatchlists: (state, payload) => {
      state.data.news_items = payload;
    },
    setOnchainAddressFolders: (state, payload) => {
      state.data.onchain_addresses = payload;
    },
    createWatchlist: (state, payload) => {
      state.data[payload.type].push(payload.watchlist);
    },
    updateWatchlist: (state, payload) => {
      const index = state.data[payload.type].findIndex(x => x.id === payload.watchlist.id);
      state.data[payload.type][index] = { ...state.data[payload.type][index], ...payload.watchlist };
    },
    deleteWatchlist: (state, watchlistId) => {
      let type = 'coins';
      let index = state.data[type].findIndex(x => x.id == watchlistId);
      if (index == -1) {
        type = 'companies';
        index = state.data[type].findIndex(x => x.id == watchlistId);
        if (index == -1) {
          type = 'apefluencer_accounts';
          index = state.data[type].findIndex(x => x.id == watchlistId);
          if (index == -1) {
            type = 'news_items';
            index = state.data[type].findIndex(x => x.id == watchlistId);
          }
          if (index == -1) {
            type = 'onchain_addresses';
            index = state.data[type].findIndex(x => x.id == watchlistId);
          }
        }
      }
      if (index != -1) state.data[type].splice(index, 1);
    },
    setLoaded: (state, type) => {
      if (type == 'all') {
        state.data.loaded['coins'] = true;
        state.data.loaded['companies'] = true;
        state.data.loaded['apefluencer_accounts'] = true;
        state.data.loaded['news_items'] = true;
        state.data.loaded['onchain_addresses'] = true;
      } else state.data.loaded[type] = true;
    },
    resetLoaded: (state, type) => {
      if (type == 'all') {
        state.data.loaded['coins'] = false;
        state.data.loaded['companies'] = false;
        state.data.loaded['apefluencer_accounts'] = false;
        state.data.loaded['news_items'] = false;
        state.data.loaded['onchain_addresses'] = false;
      } else state.data.loaded[type] = false;
    }
  }
};
